import { render, staticRenderFns } from "./floating-bar-user.vue?vue&type=template&id=33b04b3e&scoped=true"
import script from "./floating-bar-user.vue?vue&type=script&lang=js"
export * from "./floating-bar-user.vue?vue&type=script&lang=js"
import style0 from "./floating-bar-user.vue?vue&type=style&index=0&id=33b04b3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b04b3e",
  null
  
)

export default component.exports